export default __webpack_public_path__ + "static/media/menu-vip-logo-platinum.0292eada.webp";